import { Mutation } from "@apollo/client/react/components";
import React, { ReactElement } from "react";
import ToggleUpvoteMutation from "~/lib/mutations/ToggleUpvoteMutation";
import {
  IToggleUpvoteMutation,
  IToggleUpvoteMutationVariables,
} from "~/lib/mutations/__generated__/ToggleUpvoteMutation.generated";
import { IUpvoteTargetType } from "~/types/types";

interface IToggleUpvoteProps {
  upvotesCount: number;
  viewerDidUpvote: boolean;
  targetId: string;
  targetType: IUpvoteTargetType;
  entityType:
    | "Product"
    | "Story"
    | "Project"
    | "StoryComment"
    | "ProjectComment"
    | "ThreadComment"
    | "ResourceComment"
    | "QuestionComment"
    | "RecommendationEndorsementComment"
    | "ReportComment";
  children: (toggle: () => void) => ReactElement | null;
}

export default function ToggleUpvote({
  upvotesCount,
  viewerDidUpvote,
  targetId,
  targetType,
  entityType,
  children,
  ...props
}: IToggleUpvoteProps): ReactElement | null {
  if (!entityType) {
    return null;
  }

  return (
    <Mutation<IToggleUpvoteMutation, IToggleUpvoteMutationVariables>
      mutation={ToggleUpvoteMutation}
      variables={{
        targetId,
        targetType,
      }}
      {...props}
    >
      {(toggleUpvote) => {
        return children(() => {
          toggleUpvote({
            optimisticResponse: {
              __typename: "Mutation",
              toggleUpvote: {
                __typename: guessTypename(targetType, entityType as any) as any,
                _id: targetId,
                viewerDidUpvote: !viewerDidUpvote,
                upvotesCount: upvotesCount + (viewerDidUpvote ? -1 : 1),
              },
            },
          });
        });
      }}
    </Mutation>
  );
}

function guessTypename(
  targetType: IUpvoteTargetType,
  entityType: "Product" | "Story" | "Project" | "StoryComment" | "ProjectComment",
): string {
  if (targetType === "STORY") {
    return "Story";
  } else if (targetType === "PRODUCT") {
    return "Product";
  } else if (targetType === "PROJECT") {
    return "Project";
  } else if (entityType) {
    return entityType;
  }

  throw new Error("Invalid target type");
}
